import { Context, Controller } from '@hotwired/stimulus';
import { confirmWithDialog } from 'src/confirm';

export default class ConfirmController extends Controller {
  static values = {
    message: String,
    dialog: String,
  };

  declare hasDialogValue: boolean;

  declare messageValue: string;

  constructor(props: Context) {
    super(props);

    this.onConfirm = this.onConfirm.bind(this);
  }

  public connect(): void {
    this.element.addEventListener('click', this.onConfirm);
  }

  private onConfirm(e: Event) {
    if (!confirmWithDialog(this.messageValue, this.element as HTMLElement)) {
      e.stopPropagation();
      e.preventDefault();
    }
  }
}
